var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container top10"},[_c('h2',{staticClass:"homeTitle"},[_vm._v("\n    销量排名TOP10\n  ")]),_c('div',{staticClass:"charBox"},[_c('div',{staticStyle:{"width":"100%","height":"380px"},attrs:{"id":"top"}})])])
}]

export { render, staticRenderFns }